import { recordEvent } from "app/analytics";
import { AnalyticsEventType } from "app/types";
import { Course } from "./types";

export enum CourseHintType {
  // ステージ 1 のレベル 1 の、手順を教えるガイド
  TIPS = "tips",
  // 右の「ヒント」のパネル
  GUIDE = "guide",
}

// 今遊んでいるレベル。実行の回数・かかった時間・ヒントを見たかを、画面をまたいで数える
type LevelSession = {
  course: Course;
  stage: number;
  level: number;
  startedAt: number;
  attempt: number;
  hintUsed: boolean;
  cleared: boolean;
};

let session: LevelSession | null = null;

const levelParams = (s: LevelSession) => ({ course: s.course, stage: s.stage, level: s.level });

const durationSec = (s: LevelSession) => Math.round((Date.now() - s.startedAt) / 1000);

/** レベルの画面を開いた */
export const startCourseLevel = ({
  course,
  stage,
  level,
  isClearedBefore,
}: {
  course: Course;
  stage: number;
  level: number;
  isClearedBefore: boolean;
}) => {
  session = {
    course,
    stage,
    level,
    startedAt: Date.now(),
    attempt: 0,
    hintUsed: false,
    cleared: false,
  };
  recordEvent(AnalyticsEventType.COURSE_LEVEL_START, {
    ...levelParams(session),
    is_cleared_before: isClearedBefore ? 1 : 0,
  });
};

/** 実行して結果が出た。はじめて成功したときは COURSE_LEVEL_CLEAR も送る */
export const recordCourseLevelRun = ({
  success,
  blockCount,
}: {
  success: boolean;
  blockCount: number;
}) => {
  if (!session) return;
  session.attempt += 1;
  recordEvent(AnalyticsEventType.COURSE_LEVEL_RUN, {
    ...levelParams(session),
    result: success ? "success" : "failure",
    attempt: session.attempt,
    block_count: blockCount,
  });
  if (success && !session.cleared) {
    session.cleared = true;
    recordEvent(AnalyticsEventType.COURSE_LEVEL_CLEAR, {
      ...levelParams(session),
      attempt: session.attempt,
      duration_sec: durationSec(session),
      hint_used: session.hintUsed ? 1 : 0,
    });
  }
};

export const recordCourseHint = (hintType: CourseHintType) => {
  if (!session) return;
  session.hintUsed = true;
  recordEvent(AnalyticsEventType.COURSE_HINT_SHOW, {
    ...levelParams(session),
    hint_type: hintType,
  });
};

/** レベルの画面を出た。クリアしていなければ COURSE_LEVEL_EXIT を送る */
export const exitCourseLevel = () => {
  if (session && !session.cleared) {
    recordEvent(AnalyticsEventType.COURSE_LEVEL_EXIT, {
      ...levelParams(session),
      attempt: session.attempt,
      duration_sec: durationSec(session),
    });
  }
  session = null;
};
